/* =====================================================
   Field Validators
===================================================== */

// Full Name: required, min 2 chars
 const validateFullName = (value = "") => {
  if (!value.trim()) return "Full name is required";
  if (value.trim().length < 2)
    return "Full name must be at least 2 characters";
  return "";
};

// Mobile: exactly 10 digits
 const validateMobile = (value = "") => {
  if (!value) return "Mobile number is required";
  if (!/^\d{10}$/.test(value))
    return "Mobile number must be exactly 10 digits";
  return "";
};

// Email (optional)
 const validateEmail = (value = "") => {
  if (!value) return "";
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value))
    return "Invalid email address";
  return "";
};

/* =====================================================
   MAIN FIELD ERROR RESOLVER
===================================================== */

export const getFieldError = (field, value) => {
  switch (field.name) {
    case "fullName":
      return validateFullName(value);

    case "mobile":
      return validateMobile(value);

    case "email":
      return validateEmail(value);

    default:
      if (field.required && !value) {
        return `${field.label} is required`;
      }
      return "";
  }
};

/* =====================================================
   FORM LEVEL VALIDATION
===================================================== */

export const isFormValid = (fields, values) => {
  return fields.every(
    (field) => !getFieldError(field, values[field.name])
  );
};
